import { Notification } from '@/types';
import { jsonClient } from '../config';

export function getNotificationsList(offset?: number, limit?: number) {
  return jsonClient.get<Notification.NotificationsResponse>('/admin/notification/', { params: { offset, limit } })
}

export function createNotification(group: Notification.NotificationGroup, type: Notification.NotificationType, text: string, users?: number[]) {
  return jsonClient.post<Notification.NotificationItem>('/admin/notification/', { group, type, text, users })
}